module.exports = __webpack_public_path__ + "img/utahfield.a83414d4.png";